import React, { useState, useRef } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";

import Feed from "./views/Feed";
import TeaserForm from "./views/TeaserForm";
import Buy from "./views/Buy/Buy";
import Buy2 from "./views/Buy2/Buy2";
import News from "./views/News/News";
import Pay from "./views/Pay/Pay";
import TeaserStat from "./views/TeaserStat/TeaserStat";
import Category from "./views/Category/Category";
import TeaserAggregatorView from "./views/TeaserAggregator/TeaserAggregatorView";
import TeaserModeration from "./views/TeaserModeration/TeaserModeration";
import TeaserEdit from "./views/TeaserEdit/TeaserEdit";
import TeaserEditModal from "./views/TeaserEdit/TeaserEditModal";
import TeaserStatModal from "./views/TeaserStat/TeaserStatModal";
import TeasersLog from "./views/TeasersLog/TeasersLog";
import Perm from "./views/Perm/Perm";

import NavMenuComponent from "./components/NavMenuComponent";

import useTitle from "./hooks/useTitle";

import * as urls from "./utils/urls";
import { TimeTrackingControls } from "./components/TimeTrackingControls";

const AppSwitch = ({ location }) => {
  const prevLocationRef = useRef(location);
  const prevLocation = prevLocationRef.current;
  const isModal = !!(
    location.state &&
    location.state.modal &&
    prevLocation !== location
  ); // not initial render

  useTitle("Content Panel (CNTN.)", []);

  if (prevLocation != location && !isModal) {
    prevLocationRef.current = location;
  }

  return (
    <>
      <div className="wrapper">
        <div className="menu-wrapper">
          <NavMenuComponent />
        </div>

        <div className="content-wrapper">
          <Switch location={isModal ? prevLocation : location}>
            <Redirect from="/" to={urls.teaserList()} exact />
            <Route path={urls.teaserList()} component={Feed} />
            <Route path={urls.teaserAdd()} component={TeaserForm} exact />
            <Route
              path={urls.teaserAddAggregator()}
              component={TeaserAggregatorView}
            />
            <Route path={urls.buy()} component={Buy} />
            <Route path={urls.buy2()} component={Buy2} />
            <Route path={urls.teaserStat(":id")} component={TeaserStat} />
            <Route path={urls.news()} component={News} />
            <Route path={urls.pay()} component={Pay} />
            <Route path={urls.categories()} component={Category} />
            <Route path={urls.moderate()} component={TeaserModeration} />
            <Route path={urls.teaserEdit(":id")} component={TeaserEdit} />
            <Route path={urls.log()} component={TeasersLog} />
            <Route path="/perm" component={Perm} />
          </Switch>

          {isModal && (
            <Route path={urls.teaserEdit(":id")} component={TeaserEditModal} />
          )}
          {isModal && (
            <Route path={urls.teaserStat(":id")} component={TeaserStatModal} />
          )}
        </div>
      </div>
      <TimeTrackingControls />
    </>
  );
};

export default AppSwitch;
